const pattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,63}$/;
export default function (value) {
    return pattern.test(value);
}